<app-navbar-small></app-navbar-small>


<!--<h1>Current Section : [{{currentSection}}]</h1>-->
<div style="padding-top: 15px">
 <div class="row ">


    <div class="col-md-3 " style=" position: sticky; padding-top: 10px; padding-left: 25px">
      <div class=" card pink 400 topic_card">
        <p class="text-white" style="font-weight: bold; text-align: center; padding-top: 7px">{{currentSection}}</p>
      </div>
   <div>
      <div class="container" style="padding-top: 10px;">
<div (click)="scrollTo('section1')" [ngClass]="{ 'current-section': currentSection === 'What is Asips?' }"> What is Asips?
</div>
<div (click)="scrollTo('section2')" [ngClass]="{ 'current-section': currentSection === 'How to use Asips?' }"> How to use Asips?
</div>
<div (click)="scrollTo('section3')" [ngClass]="{ 'current-section': currentSection === 'What Gaussian Hellinger EFDT?' }"> What Gaussian Hellinger EFDT?
</div>
<div (click)="scrollTo('section4')" [ngClass]="{ 'current-section': currentSection === 'How the Asips works?' }"> How the Asips works?
</div>
<br/>
</div>
    </div>
    </div>
<!--  </div>-->
<div class="col-md-8 " id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)" style="height: 100vh; overflow-y: scroll; padding-top: 10px">
  <div id="section1">
    <div class="m-lg-6" >
      <div class="row d-flex justify-content-center">
        <h2 style="color: #0D446E"><b>What is Asips?</b></h2>

      </div>

      <div class="row d-flex justify-content-center">
        <div class="col-8">
          <p class="">Asips is a system which demonstrate the use of a novel algorithm on
            <a href="https://archive.ics.uci.edu/ml/datasets/HTRU2">HTRU2</a> dataset. Also, Asips provide the capability
            of comparing those results with the results from other existing stream classification algorithms.
            The algorithm is capable of learning from new confirmed data; it uses delayed progressive evaluator and
            developed according to kappa architecture
            (<a href="https://towardsdatascience.com/machine-learning-for-streaming-data-with-creme-dacf5fb469df">More about kappa architecture</a>).
            Thus, user can confirm the correctness of predictions, then model will update(learn) from new confirmed data.

            Also, you can view and explore confirmed data <a routerLink="/view_pulsar">here</a> and <a routerLink="/view_pulsar_non_pulsar">here</a>.
          </p>
        </div></div>

    </div>
  </div>
  <div id="section2">
    <div class="m-lg-4">
      <div class="row d-flex justify-content-center">
        <h2 style="color: #0D446E"><b>How to use Asips?</b></h2>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-8">

          <p>
            1) Pretrain with conformed data (Home => Pretrain). <br>
            2) Enter number of samples (x) that you want to make a stream with and click predict.
            (This will simulate a stream with x number of samples and will start making predictions) <br>
            3) You can view pretrain info and logs. <br>
            4) Click "Verify, Update Model and See Current Accuracy" button or navigate to verify page. <br>
            5) For the demo, I added the actual class as well. So can do the verification by looking that. (
            In actual process the verification will be done by experts after following an astronomical verification process.) <br>
            6) You can view verified data by navigating to the "View Pulsar Signals" page or "View Pulsar and non Pulsar Signals" page.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div id="section3">
    <div class="m-lg-4 ">
      <div class="row d-flex justify-content-center">
        <h2 style="color: #0D446E"><b>What Gaussian Hellinger Extremely Fast Decision Tree?</b></h2>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-8">

          <p class=""> TODO: Add explanation for GH-EFDT <br><br>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </div>
      </div>
    </div>
  </div>
  <div id="section4">
    <div class="m-lg-4 ">
      <div class="row d-flex justify-content-center">
        <h2 style="color: #0D446E"><b>How this works?</b></h2>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-8">

          <p class="">The below figure shows the architecture of the system “Asips”. The system has three
            main components. Server is the component that will include most of the contribution of the
            research. Firebase and user-interface used for storing and presenting data in real-time. The proposed
            algorithm implemented inside the server. Once the input signals reach the system via streaming
            pipelines, the proposed algorithm should make the prediction before the next sample arrives.
            If it is predicted as a pulsar signal, the signal data will be stored in the firebase real-timedatabase.
            Keeping a few non-pulsar signals in the storage was raised as a requirement when
            gathering requirements. Hence if the prediction is a non-pulsar, once per a specific period, a non-pulsar data will be stored in the database. Once an instance of data saved to the firebase,
            the user interface will be updated immediately. <br> </p>

          <img src="/assets/System%20Architecture%20Design.png" class=".img-fluid" style=" max-width: 100%; height: auto;">
          <p class=""><br> Since firebase designed to work for serverless
            architecture, firebase can directly connect with the user interface without an extra middle layer.
            But the proposed system is not following the serverless architecture
            completely due to the system have computationally intensive tasks that can’t execute on a
            client. In such situations, there is an architecture explained by firebase, where the client will
            communicate with the firebase as well as the server <a href="https://firebase.googleblog.com/2013/03/where-does-firebase-fit-in-your-app.html">
              (See more about these architectures)</a>. The user interface was developed according to MVVM (Model-View-ViewModel) architecture. </p>

        </div>
      </div>
    </div>
  </div>
</div>
<br/>
</div>
</div>

